import React from 'react';
import Input from './Input';

interface FieldsetProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  htmlFor: string;
  label?: string;
  fieldsetClassName?: string;
  hint?: string;
  hintClassName?: string;
  hintId?: string;
  hintHidden?: boolean;
  children?: React.ReactNode;
}

const Fieldset = React.forwardRef<HTMLInputElement, FieldsetProps>(
  (
    {
      id,
      htmlFor: _htmlFor,
      label,
      hint,
      hintClassName,
      hintId,
      hintHidden,
      fieldsetClassName,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <fieldset className={fieldsetClassName || 'fieldset'}>
        {children ? (
          children
        ) : (
          <Input
            ref={ref}
            id={id}
            label={label}
            hint={hint}
            hintClassName={hintClassName}
            hintId={hintId}
            hintHidden={hintHidden}
            {...props}
          />
        )}
      </fieldset>
    );
  }
);

Fieldset.displayName = 'Fieldset';

export default Fieldset;
